import { cn } from '../lib/cn'

// The wine i stays selectable; an ink dotless ı over it leaves only the dot wine.
export function BrandWordmark({ className }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Slibby"
      data-slot="brand-wordmark"
      className={cn('font-heading font-medium tracking-[-0.02em] text-foreground', className)}
    >
      Sl
      <span className="relative inline-block">
        <span className="text-action">i</span>
        <span aria-hidden="true" className="absolute inset-0 select-none text-foreground">
          ı
        </span>
      </span>
      bby
    </span>
  )
}
